export const GRADE = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
};

// Color scheme for medical grades (A = healthy, E = severe)
export const GRADE_COLORS = {
  A: {
    background: '#f0f8f0',
    border: '#d4edda',
    text: '#28a745',
    accordionBg: '#f0f8f0',
    accordionHeaderBg: '#e8f5e8',
  },
  B: {
    background: '#fffbf0',
    border: '#ffeaa7',
    text: '#856404',
    accordionBg: '#fffbf0',
    accordionHeaderBg: '#fff3cd',
  },
  C: {
    background: '#fff5f0',
    border: '#ffcc99',
    text: '#d2691e',
    accordionBg: '#fff5f0',
    accordionHeaderBg: '#ffe4cc',
  },
  D: {
    background: '#fff0f0',
    border: '#ffb3b3',
    text: '#dc3545',
    accordionBg: '#fff0f0',
    accordionHeaderBg: '#ffcccc',
  },
  E: {
    background: '#f8f0f0',
    border: '#ff9999',
    text: '#a94442',
    accordionBg: '#f8f0f0',
    accordionHeaderBg: '#ffb3b3',
  },
  H: {
    background: '#f0f4ff',
    border: '#b3ccff',
    text: '#4169e1',
    accordionBg: '#f0f4ff',
    accordionHeaderBg: '#d9e5ff',
  },
  DEFAULT: {
    background: '#fafafa',
    border: '#e0e0e0',
    text: '#333333',
    accordionBg: '#f5f5f5',
    accordionHeaderBg: '#e0e0e0',
  },
};
